import { Improvements, SubjectData } from '@aloft/toolkit-shared';

import {
  CompPropertyDataState,
  PropertyDataState,
  SubjectPropertyDataState,
} from '../../../types.ts';

export const getCurrentImprovements = (current: PropertyDataState, arv?: boolean): Improvements | undefined => {
  const { id } = current;
  const isSubject = id === 'subject';

  const propertyData = isSubject
    ? (current as SubjectPropertyDataState).subjectData
    : (current as CompPropertyDataState).compData;

  if (isSubject && arv) {
    return (propertyData as SubjectData).editableData.arv?.improvements;
  }

  return propertyData.editableData.improvements;
};
